import axios from "@/utils/request";

export function getRecord(data) {
  return axios({
    url: "/historys",
    method: "get",
    params: data,
  });
}
